fragment LandingPageStubFragment on Page {
    id
    name
    htmlUrlPath
    createdTime
    lastModifiedTime
    customPublishedUrl
    nutshellPublishedUrl
    hasUnpublishedChanges
    thumbnailUrl
    status
    numViews
    backgroundColor
    publishedVersion {
        id
        publisherUser {
            id
            name
        }
    }
}
